const erp_scopes = {
    TIMELINE_STATUS : 'erp:timeline:status',
};

export default erp_scopes;
